export interface JobSkill {
    skill: string
    qualification: 'nice_to_have' | 'must_have'
}

export interface Job {
    locator: string;
    client_locator: string;
    talent_locator: string;
    status: string;
    location: string;
    type: string;
    tags: any[];
    posting_date: Date;
    expiry_date: Date;
    title: string;
    level: string;
    must_haves: any[];
    nice_to_haves: any[];
    pay_type: string;
    pay_amount: string;
    pay_amount_max: string;
    pay_rate: string;
    pay_currency: string;
    duration: number;
    duration_type?: string;
    applicants: any[];
    description: string;
    responsibilities: string[];
    skills: JobSkill[];
    questions?: {id: number, question: string}[];
    deliverables?: string[];
    work_site: string;
    primary_language: string;
    completed_date: string;
    specialization: string;
    creation_method?: 'manual' | 'ai';
}

export interface AddJobRequest {
    client_locator: string;
    location?: string;
    type: string;
    tags: any[];
    title: string;
    level: string;
    pay_type?: SalaryType;
    pay_amount: number;
    pay_amount_max?: number;
    pay_rate: string;
    pay_currency: string;
    duration: number;
    description: string;
    duration_type?: string;
    responsibilities: string[];
    skills: JobSkill[];
    questions?: JobQuestion[];
    deliverables?: string[];
    work_site: string;
    primary_language: string;
    status: string;
    specialization: string;
    creation_method?: 'manual' | 'ai';
}

//TODO: Phase this interface out and use the IJobPosting interface
export interface IJobByStatus {
    locator: string;
    status: string;
    title: string;
    start_date: string;
    type: string;
    posting_date: string;
    completed_date: string;
    applicants: string[];
    talent: {
        locator: string;
        first_name: string;
        last_name: string;
        title: string;
        profile_picture: string;
    }
    client: {
        locator: string;
        first_name: string;
        last_name: string;
        profile_picture: string;
        company: string;
    }
}

export interface IJobPosting {
  locator: string;
  status: string;
  title: string;
  start_date: string;
  type: string;
  posting_date: string;
  completed_date: string;
  applicants: string[];
  creation_method?: 'manual' | 'ai';
  talent: {
      locator: string;
      first_name: string;
      last_name: string;
      title: string;
      profile_picture: string;
  }
  client: {
      locator: string;
      first_name: string;
      last_name: string;
      title: string;
      profile_picture: string;
      company: string;
  }
}

export interface IClientJobPostingsResponse {
  ShortTerm: IJobPosting[];
  PartTime: IJobPosting[];
  FullTime: IJobPosting[];
  Internship: IJobPosting[];
  Drafts: IJobPosting[];
}

export interface IMarketplaceJob {
    locator: string;
    title: string;
    work_site: string;
    type: string;
    applicants: string[];
    posting_date: string;
    status: string;
    talent_locator: string;
    specialization: string;
    client: {
        locator: string;
        first_name: string;
        last_name: string;
        profile_picture: string;
        country: string;
        company: string;
    }
}

export interface Responsibility {
    _id: number;
    responsibility: string;
}

export interface Qualification {
    _id: number;
    qualification: string;
}

export interface JobQuestion {
    id: number;
    question: string;
}

export interface Deliverable {
    _id: number;
    deliverable: string;
}

export const JobTitle = [
    "Software Developer",
    "Digital Marketer",
    "Graphic Designer",
    "Content Writer",
    "Data Analyst",
    "Customer Support Specialist",
    "Project Manager",
    "Accountant",
    "Human Resources Manager",
    "Social Media Manager",
    "UX/UI Designer",
    "SEO Specialist",
    "Business Analyst",
    "Sales Representative",
    "Technical Support Engineer",
    "Product Manager",
    "Virtual Assistant",
    "Online Tutor",
    "Medical Coder",
    "Legal Assistant"
  ];
  
  export const JobType = [
    "Short-term",
    "Internship",
    "Part-time",
    "Full-time",
  ];
  
  export const DurationType = [
    'Days', 
    'Months', 
    'Years'
 ];

  export const WorkSite = [
    "Remote",
    "In person",
    "Hybrid"
  ];
  
  export const PaymentType = [ 
    "One-time",
    "Hourly",
    "Weekly",
    "Bi-weekly",    
    "Monthly"
  ];

  export enum JobCreationSteps {
    'Preferences' = 1,
    'Description',
    'Responsibilities',
    'Qualifications',
    'Deliverables',
    'Questions'
  }

  export interface AcceptJobRequest {
    locator: string;
    body: {
        talent_locator: string;
    }
  }

  export interface MarkJobReadyRequest {
    locator: string;
    body: {
        receiver_locator: string;
    }
  }
  
  export interface CompleteJobRequest {
    locator: string;
    body: {
        receiver_locator: string;
    }
  }

  //TODO: Make the job type array and constants one thing, maybe a class that has a to array function?
  export const JobConstants = {
    JobType: {
        ShortTerm: 'Short-term',
        Internship: 'Internship', 
        PartTime: 'Part-time', 
        FullTime: 'Full-time'
    },
    SalaryType: {
      Fixed: 'Fixed',
      Range: 'Range'
    }
  }
  export type SalaryType = keyof typeof JobConstants.SalaryType;

  export const JobStatus = {
    Draft: 'draft', 
    Open: 'open', 
    InReview: 'in_review', 
    Negotiating: 'negotiating', 
    Hired: 'hired', 
    InProgress: 'in_progress', 
    ReadyForReview: 'ready_for_review', 
    Finished: 'finished', 
    Cancelled: 'cancelled'
  }
